import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { ErrorCode } from '../../../../ErrorCode';
import { USER_MNG, UpdateUserInfos } from '../../../../function/UserManageModel';
import OKCancelDialog from '../../../atoms/Dialog/OKCancelDialog';

import { SettingsState } from '../../../organisms/SelectSettings';

import LoginUserSettingGrid from './LoginUserSettingGrid';
import LoginUserSettingFooter from './LoginUserSettingFooter';
import { TableBaseStyle, LoginUserSettingStyle } from './LoginUserSettingStyle';
import { isMailChack } from './LoginUserSetting';
import SimpleDialog from '../../../atoms/Dialog/SimpleDialog';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import { useModal } from '../../../../function/useModal';

type LoginUserSettingPage = { editData: SettingsState };

const LoginUserSettingPage: React.FC<LoginUserSettingPage> = (props: LoginUserSettingPage) => {
  const { t } = useTranslation();
  const pageStyle = LoginUserSettingStyle();

  const [messageDialogOpen, setMessageDialogOpen] = React.useState(false);
  const [okCancelDialogOpen, setOkCancelDialogOpen] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState<string>('');

  const [cellRefresh, setCellRefresh] = useState<string>('');
  const [cells, setCells] = useState<USER_MNG[]>([]);
  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [dlgmsg, setDlgmsg] = useState<string>('');
  const [removeIdx, setRemoveIdx] = useState<number[]>([]);
  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('DeviceRegist.はい', 'はい')}
      cancel={t('DeviceRegist.いいえ', 'いいえ')}
    />
  ) : null;

  useEffect(() => {
    props.editData.SaveFunction = saveProc;
    props.editData.IsUpdate = false;
  }, [props.editData.CancelCondition]);

  const updateCells = (newCells: USER_MNG[]): void => {
    setCells([...newCells]);

    props.editData.Target = newCells;
    props.editData.IsUpdate = newCells.some((um) => um.isEdit);
  };

  /**
   * 入力チェック
   * @param cells 
   * @returns 
   */
  const isDuplicate = (cells: USER_MNG[]): boolean => {
    var ret = false;
    //現在のパスワードがないユーザを検索
    var newUsers = cells.filter((r) => r.USER_ID !== '' && r.hasPassword === false);
    //現在のパスワードがあるユーザを検索
    var existUsers = cells.filter((r) => r.hasPassword === true);

    console.debug(['cells', cells]);
    console.debug(['newUsers', newUsers]);

    const rmvidx: number[] = [];
    for (var i = 0; i < newUsers.length; i++) {
      //同じユーザIDがないかを検索
      var index = existUsers.findIndex((r) => r.USER_ID == newUsers[i].USER_ID);
      if (index != -1) {
        //同じユーザIDがある場合、クリア
        ret = true;
        var clearIndex = cells.findIndex((r) => r.ENT_NO == newUsers[i].ENT_NO);
        rmvidx.push(clearIndex);
      }
    }
    setRemoveIdx(rmvidx);

    return ret;
  };

  // const isInputCheck = (cells: USER_MNG[]): boolean => {
  //   var ret = false;
  //   //ユーザーIDが空じゃないを検索
  //   var userIDCheck = cells.filter((r) => r.USER_ID.trim() !== '');
  //   //パスワードが空じゃないを検索
  //   var passWordCheck = cells.filter((r) => r.hasPassword === true || r.PASSWORD !== '');

  //   for (var i = 0; i < userIDCheck.length; i++) {
  //     //パスワードがあるかを検索
  //     if (userIDCheck[i].PASSWORD === '' || userIDCheck[i].hasPassword == false) {
  //       ret = true;
  //     }
  //   }

  //   for (var i = 0; i < passWordCheck.length; i++) {
  //     //ユーザIDがあるかをチェック
  //     if (passWordCheck[i].PASSWORD === '' || passWordCheck[i].hasPassword == false) {
  //       ret = true;
  //     }
  //   }

  //   return ret;
  // };

  const handleOkButton = () => {
    if (isDuplicate(cells)) {
      setShowMessage(t('LoginUserSettingPage.ユーザIDが重複しています', 'ユーザIDが重複しています'));
      setMessageDialogOpen(true);
      setCells([...cells]);
      return;
    }

    // if (isMailChack(cells)) {
    //   setShowMessage(t('LoginUserSettingPage.ユーザID登録箇所で、メールアドレスが空白の箇所があります', 'ユーザID登録箇所で、メールアドレスが空白の箇所があります'));
    //   setMessageDialogOpen(true);
    //   return;
    // }

    var targets = cells.filter((r) => r.isEdit);
    if (targets.length == 0) {
      setCellRefresh(dayjs().format());
    } else {
      setShowMessage(t('LoginUserSettingPage.設定を保存しますか？', '設定を保存しますか？'));
      setOkCancelDialogOpen(true);
    }
    return;
  };
  const handleCalcelButton = () => {
    if (props.editData.IsUpdate) {
      setDlgmsg(
        t(
          'DeviceRegist.保存していないデータを破棄します。\nよろしいですか?',
          '保存していないデータを破棄します。\nよろしいですか?'
        )
      );
      actCfmDlg
        .open()
        .apply((_) => {
          props.editData.UpdateCancel();
          setCellRefresh(dayjs().format());
        })
        .cancel(() => { });
    }
  };
  /**
   *エラーコードメッセージ出力
   * @param errorCode 
   */
  const updateErrorInfos = (errorCode: number) => {
    if (errorCode == ErrorCode.ERR_CODE_USER_USER_ID_DUPLICATE) {
      setShowMessage(t('LoginUserSettingPage.ユーザIDが重複しています', 'ユーザIDが重複しています'));
      setMessageDialogOpen(true);
      setOkCancelDialogOpen(false);
    } else if (errorCode == ErrorCode.ERR_CODE_USER_MAILADRESS) {
      setShowMessage(t('LoginUserSettingPage. メールアドレスのフォーマットが正しくありません ', ' メールアドレスのフォーマットが正しくありません '));
      setMessageDialogOpen(true);
      setOkCancelDialogOpen(false);
    } else if (errorCode == ErrorCode.ERR_CODE_SYSTEM_ERROR) {
      setShowMessage(t('LoginUserSettingPage.システムエラーが発生しました', 'システムエラーが発生しました'));
      setMessageDialogOpen(true);
      setOkCancelDialogOpen(false);
      setMessageDialogOpen(true);
    }
  }

  const handleSaveOkButton = () => {
    var targets = cells.filter((r) => r.isEdit);

    UpdateUserInfos(targets).then((r) => {
      //パスワード変更を反映
      if (r.ErrorCode == 0) {
        setShowMessage(t('LoginUserSettingPage.設定を保存しました', '設定を保存しました'));
        setMessageDialogOpen(true);
        setOkCancelDialogOpen(false);
        setCellRefresh(dayjs().format());
        props.editData.IsUpdate = false;
      } else {
        updateErrorInfos(r.ErrorCode);
      }
    });
  };
  const saveProc = (target: object): Promise<string> => {
    return new Promise((resolve, reject) => {
      const cells = target as USER_MNG[];
      if (cells) {
        var targets = cells.filter((r) => r.isEdit);
        UpdateUserInfos(targets)
          .then((r) => {
            if (r.ErrorCode == 0) {
              resolve('done');
            } else {
              reject(r.ErrorCode);
              updateErrorInfos(r.ErrorCode);
            }
          })
          .catch((reason) => reject(reason));
      } else {
        reject('data error');
      }
    });
  };

  return (
    <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 2 }}>
      <Grid item xs={12}>
        <LoginUserSettingGrid
          updateCells={updateCells}
          tableContainerStyle={pageStyle.tableContainer}
          cellRefresh={cellRefresh}
          removeIndexes={removeIdx}
        />
      </Grid>
      <Grid item xs={12}>
        <LoginUserSettingFooter onOK={() => handleOkButton()} onCancel={() => handleCalcelButton()} />
      </Grid>
      <OKCancelDialog
        open={okCancelDialogOpen}
        onOK={() => handleSaveOkButton()}
        onCancel={() => setOkCancelDialogOpen(false)}
        title={t('LoginUserSettingPage.ユーザー管理設定', 'ユーザー管理設定')}
        okText={t('LoginUserSettingPage.OK', 'OK')}
        cancelText={t('LoginUserSettingPage.キャンセル', 'キャンセル')}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </OKCancelDialog>
      <SimpleDialog
        open={messageDialogOpen}
        onClose={() => setMessageDialogOpen(false)}
        title={t('LoginUserSettingPage.ユーザー管理設定', 'ユーザー管理設定')}
        okText={t('LoginUserSettingPage.OK', 'OK')}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </SimpleDialog>
      {cfmdlg}
    </Grid>
  );
};

export default LoginUserSettingPage;
